<template>
    <section class="py-10 xl:pt-[60px] xl:pb-[96px] px-[2vw] xl:px-content mt-[25vh] md:mt-[15vh] xl:mt-[5vh] will-change" :data-scroll-section="inner == 'false'">
        <div class="bg-white flex  md:flex-row items-center px-[6vw] xl:px-0"
            :class="{'flex-col-reverse': blockData.block_orientation === 'text-left', 'flex-col': blockData.block_orientation === 'text-right'}"
            >

            <template v-if="blockData.block_orientation === 'text-left'">
                <!-- text -->
                <div class="md:w-1/2 pb-10 md:pt-10 xl:pb-14">
                    <div class="xl:w-8/12 xl:mx-auto will-change" data-scroll data-scroll-speed="1.5" data-scroll-delay=".05" data-scroll-class="xyz-in" xyz="fade down duration-15">
                        <div class="text-xs leading-5 tracking-desk uppercase text-navy-blue-03 xl:text-sm mb-4 xl:mb-7 " v-show="blockData.kicker">{{ blockData.kicker }}</div>
                        <h2 class="text-4xl xl:text-heading text-navy-blue-01 mb-6 xl:mb-8 " v-show="blockData.title">{{ blockData.title }}</h2>
                        <div class="text-navy-blue-02" v-show="blockData.text" v-html="blockData.text"></div>
                        <a v-show="blockData.cta" :href="blockData.cta.url" class="btn" :class="ctaStyle">
                            {{ blockData.cta.title }}
                            <svg v-if="blockData.cta_style !== 'dark'" class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                                <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square" />
                            </svg>
                        </a>
                    </div>
                </div>
                <!-- ./text -->

                <!-- img -->
                <div class="md:w-1/2">
                    <div class="img-holder pb-[16%] md:pl-[17%] xl:pl-0 xl:pr-[17%] w-full h-auto relative">
                        <img class="w-full mt-[-50%] xl:mt-[-25%]" v-show="blockData.image" :src="blockData.image.url" :alt="blockData.image.alt" data-scroll data-scroll-speed="2">
                    </div>
                </div>
                <!-- ./img -->
            </template>

            <template v-else>
                <!-- img -->
                <div class="md:w-1/2">
                    <div class="img-holder pb-[16%] md:pr-[17%] xl:pr-0 xl:pl-[17%] w-full h-auto relative">
                        <img class="w-full mt-[-50%] xl:mt-[-25%]" v-show="blockData.image" :src="blockData.image.url" :alt="blockData.image.alt" data-scroll data-scroll-speed="2">
                    </div>
                </div>
                <!-- ./img -->

                <!-- text -->
                <div class="md:w-1/2 pb-10 md:pt-10 xl:pb-14">
                    <div class="xl:w-8/12 xl:mx-auto will-change" data-scroll data-scroll-speed="1.5" data-scroll-delay=".05" data-scroll-class="xyz-in" xyz="fade down duration-15">
                        <div class="text-xs leading-5 tracking-desk uppercase text-navy-blue-03 xl:text-sm mb-4 xl:mb-7 " v-show="blockData.kicker">{{ blockData.kicker }}</div>
                        <h2 class="text-4xl xl:text-heading text-navy-blue-01 mb-6 xl:mb-8 " v-show="blockData.title">{{ blockData.title }}</h2>
                        <div class="text-navy-blue-02" v-show="blockData.text" v-html="blockData.text"></div>
                        <a v-show="blockData.cta" :href="blockData.cta.url" class="btn" :class="ctaStyle">
                            {{ blockData.cta.title }}
                            <svg v-if="blockData.cta_style !== 'dark'" class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 12L21 12" stroke="#405664" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                                <path d="M18 8L22 12L18 16" stroke="#405664" stroke-width="1.2" stroke-linecap="square" />
                            </svg>
                        </a>
                    </div>
                </div>
                <!-- ./text -->
            </template>



        </div>

    </section>
</template>


<script>
    export default {
        name: 'PopOutImageTextCta',
        data() {
            return {}
        },
        mounted() {

        },
        computed: {
            ctaStyle() {
                let className = '';
                if ( this.blockData.cta_style === 'light' ) {
                    className = [
                        '',
                    ]
                }
                if ( this.blockData.cta_style === 'dark' ) {
                    className = [
                        'btn-blue',
                    ]
                }
                return className;
            }
        },
        methods: {

        },
    }
</script>
